/**
 * The signed-in user as the app first knows it: the ID token's claims. Permissions are added
 * afterwards by AuthContext.loadPermissions (GET /users/me/permissions).
 */
import type { AuthUser } from '../../types/permissions';
import { getUserAttributesFromToken } from './cognito.service';
import { TokenService } from './token.service';

export function userFromIdToken(idToken: string | null = TokenService.getIdToken()): AuthUser | null {
  const attrs = idToken ? getUserAttributesFromToken(idToken) : null;
  if (!attrs?.sub) return null;
  return {
    id: attrs.sub,
    email: attrs.email || '',
    firstName: attrs.firstName || '',
    lastName: attrs.lastName || '',
    tenantId: attrs.tenantId || '',
    providerType: attrs.providerType,
    userType: attrs.userType,
    groups: attrs.groups,
  };
}
